import { apiClient } from '@/shared/api/client'
import type { ApiCollection, ApiResource } from '@/shared/types/api'
import type {
  Organization,
  OrganizationInvitation,
  OrganizationMember,
  TokenTransaction,
} from '@/shared/types/domain'

export async function switchOrganization(organizationId: string): Promise<Organization> {
  const response = await apiClient.post<ApiResource<Organization>>('/organization/switch', {
    organization_id: organizationId,
  })
  return response.data.data
}

export interface InviteOrganizationMemberInput {
  email: string
}

export async function getOrganization(): Promise<Organization> {
  const response = await apiClient.get<ApiResource<Organization>>('/organization')
  return response.data.data
}

export async function updateOrganization(input: Partial<Organization>): Promise<Organization> {
  const response = await apiClient.patch<ApiResource<Organization>>('/organization', input)
  return response.data.data
}

export async function listOrganizationMembers(): Promise<OrganizationMember[]> {
  const response = await apiClient.get<ApiCollection<OrganizationMember>>('/organization/members')
  return response.data.data
}

export async function listOrganizationInvitations(): Promise<OrganizationInvitation[]> {
  const response = await apiClient.get<ApiCollection<OrganizationInvitation>>(
    '/organization/invitations',
  )
  return response.data.data
}

export async function inviteOrganizationMember(
  input: InviteOrganizationMemberInput,
): Promise<OrganizationInvitation> {
  const response = await apiClient.post<ApiResource<OrganizationInvitation>>(
    '/organization/invitations',
    input,
  )
  return response.data.data
}

export async function listOrganizationTokenTransactions(): Promise<TokenTransaction[]> {
  const response = await apiClient.get<ApiCollection<TokenTransaction>>(
    '/organization/token-transactions',
  )
  return response.data.data
}
